module.exports = "pegasus_template/assets/city3.png";